import React from 'react'
import { ReactComponent as IconSatis } from '../../../../../../../assets/icons/u_alert-check.svg'
import { OnePagerDoughnutChart } from '../../../../../../Portfolio_R/SummaryCharts/components/OnePagerDoughnutChart'
import { useTranslation } from 'react-i18next';

const PmrProjectsCard = ({ mp }) => {
    const { t } = useTranslation();

    return (
        <div className="pmr">
            <div className='pmrIconContent'>
                <p>PMR</p>
                <IconSatis />
            </div>
            <p>{t('extended_report.PMR_description')}</p>
            <OnePagerDoughnutChart data={mp.pmrArray} />
        </div>
    )
}

export default PmrProjectsCard